<template>
  <div class="min-h-screen bg-[#14151A] flex items-center justify-center px-4">
    <div class="max-w-md w-full text-center">
      <!-- Nasna Logo -->
      <div class="mb-8">
        <h1 class="text-4xl font-bold text-white font-Almarai">ناسنا</h1>
      </div>

      <!-- Success Animation Container -->
      <div class="mb-8 flex justify-center">
        <!-- Success Checkmark -->
        <div class="relative">
          <div class="mt-0">
            <!-- Lottie Voice Animation -->
            <Vue3Lottie
              :animationData="jsonFile"
              :height="300"
              :width="300"
              class="rounded-full"
            />
          </div>
        </div>
      </div>

      <!-- Success Message -->
      <div class="mb-8">
        <h2 class="text-2xl font-bold text-white mb-4 font-Almarai">
          تم تفعيل الاشتراك!
        </h2>
      </div>

      <!-- Continue Button -->
      <div class="space-y-4">
        <button
          @click="goHome"
          class="w-full bg-[#9d2890] hover:bg-[#8a2279] text-white font-semibold py-4 px-6 rounded-xl transition-all duration-200 font-Almarai transform hover:scale-105"
        >
          العودة للرئيسية
        </button>
      </div>

      <!-- Additional Info -->
    </div>

    <!-- Mobile Bottom Sheet -->
    <ContinueApp
      v-if="showBottomSheet && isMobile"
      ref="continueApp"
      :auto-show="false"
    />
  </div>
</template>

<script>
import { Vue3Lottie } from "vue3-lottie";
import animationData from "@/assets/success.json";
import ContinueApp from "@/components/payments/ContinueApp.vue";
export default {
  name: "CouponSuccess",
  components: {
    Vue3Lottie,
    ContinueApp,
  },
  data() {
    return {
      couponCode: "",
      expiryDate: "31/12/2025",
      lottieOptions: {
        animationData,
        loop: true,
        autoplay: true,
      },
      jsonFile: animationData,
      successStatus: false,
      isMobile: false,
      showBottomSheet: false,
    };
  },
  methods: {
    detectMobile() {
      // Check for mobile devices
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice =
        /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
          userAgent.toLowerCase()
        );
      const isSmallScreen = window.innerWidth <= 768;
      const hasTouchScreen =
        "ontouchstart" in window || navigator.maxTouchPoints > 0;

      this.isMobile = isMobileDevice || (isSmallScreen && hasTouchScreen);
      console.log("Coupon Mobile detection:", {
        userAgent: userAgent.substring(0, 50) + "...",
        isMobileDevice,
        isSmallScreen,
        hasTouchScreen,
        isMobile: this.isMobile,
        screenWidth: window.innerWidth,
      });
    },

    handleSuccessFlow() {
      const origin = localStorage.getItem("origin") || "web";
      if (this.isMobile && origin === "app") {
        // Show bottom sheet for mobile users
        this.showBottomSheet = true;

        // Trigger the bottom sheet to open
        this.$nextTick(() => {
          if (this.$refs.continueApp) {
            this.$refs.continueApp.openBottomSheet();
          }
        });
      } else {
        // Desktop users go directly to home
        this.redirectToHome();
      }
    },

    redirectToHome() {
      this.$router.push({ name: "home" });
    },

    goHome() {
      // Check if mobile before going home
      this.handleSuccessFlow();
    },
  },

  mounted() {
    // Listen for window resize to handle orientation changes
    window.addEventListener("resize", this.detectMobile);
  },

  beforeUnmount() {
    // Clean up event listener
    window.removeEventListener("resize", this.detectMobile);
  },
  created() {
    // Detect mobile device
    this.detectMobile();

    // Get coupon code from route params or query
    this.couponCode =
      this.$route.params.couponCode || this.$route.query.code || "DISCOUNT";

    // Log for debugging
    console.log("Coupon Success page loaded with code:", this.couponCode);
    console.log("Route params:", this.$route.params);
    console.log("Route query:", this.$route.query);
  },
};
</script>

<style scoped>
/* Success animation keyframes */
@keyframes bounce-in {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes checkmark {
  0% {
    stroke-dasharray: 0 50;
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dasharray: 50 50;
    stroke-dashoffset: -50;
  }
}

/* Animation classes */
.animate-bounce-in {
  animation: bounce-in 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.animate-checkmark {
  animation: checkmark 0.6s ease-in-out 0.3s both;
}

.checkmark-path {
  stroke-dasharray: 50;
  stroke-dashoffset: 50;
}

/* Button hover effects */
button:hover {
  transform: translateY(-2px);
}

button:active {
  transform: translateY(0);
}

/* Smooth transitions */
button {
  transition: all 0.2s ease-in-out;
}

/* Glow effect for success elements */
.bg-green-500 {
  box-shadow: 0 0 20px rgba(34, 197, 94, 0.3);
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .w-24 {
    width: 5rem;
    height: 5rem;
  }

  .w-12 {
    width: 2.5rem;
    height: 2.5rem;
  }
}
</style>